export default __webpack_public_path__ + "static/media/full-hobbit.b0dd6ccb.jpg";